// extracted by mini-css-extract-plugin
export default {"breakForm":"breakForm_breakForm__aT81P","noBorder":"breakForm_noBorder__a-9qb","action":"breakForm_action__gJk5d"};